'use client'

import { useDocumentInfo } from '@payloadcms/ui'

import { OrgPanelClient } from './OrgPanelClient.jsx'

// Mounted as a UI field at the top of the Organizations edit form — the
// org's operational card: dashboard link, location roster, add-location.
export function OrgPanel() {
  const { id } = useDocumentInfo()
  if (!id) return null
  return <OrgPanelClient orgId={id} />
}
